@if (loading) {
  <div  class="spinner-container" [ngStyle]="{'height': height}">
    <img src="./assets/svgs/loading.svg">
  </div>
}
@if (failed) {
  <div style="text-align: center;">
    {{'tile-spinner.error-message' | translate}}
  </div>
}
@if (loaded) {
  <div>
    <ng-content></ng-content>
  </div>
}


